<script>
import * as moment from 'moment';

export default {
  props: {
    triggerReload: Number, // increase to trigger
  },

  data: function () {
    let numDaysInPast = 30;
    return {
      fromDate: moment().add(-numDaysInPast, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),

      balances: [],
    };
  },
}
</script>

<template>
  <div class="table-responsive">

    <api-loader
      :key="`${triggerReload}/${fromDate}/${toDate}`"
      method="get"
      :url="`v1/layeradmin/pellet-food-stock-balances/${encodeURIComponent(fromDate)}/${encodeURIComponent(toDate)}`"
      @loaded="balances=$event" />

    <table class="table table-bordered table-sm small mb-0">
      <thead>
        <tr>
          <td colspan="20">

            <div class="h5 text-center m-0">
              Pellet Food Stock
            </div>

            <div class="row my-2">
              <div class="col-6 offset-md-2 col-md-4">
                <b-form-input :id="`from-${_uid}`" v-model="fromDate" type="date" size="sm"></b-form-input>
              </div>
              <div class="col-6 col-md-4">
                <b-form-input :id="`to-${_uid}`" v-model="toDate" type="date" size="sm"></b-form-input>
              </div>
            </div>

          </td>
        </tr>

        <tr>
          <td class="text-center">Date</td>
          <td class="text-center">Used (kg)</td>
          <td class="text-center">Added (kg)</td>
          <td class="text-center">Cost (R)</td>
          <td class="text-center">Silo Empty</td>
          <td class="text-center">Balance (kg)</td>
          <td class="text-center">Discrepancy (kg)</td>
        </tr>
      </thead>

      <tr v-for="balance in balances" :key="balance.date">

        <td class="text-center">
          {{balance.date | formatDate('YYYY-MM-DD')}}
        </td>

        <td class="text-center text-warning">
          {{balance.used | roundNumber(2)}}
        </td>

        <td class="text-center text-success">
          {{balance.added | roundNumber(2)}}
        </td>

        <td class="text-center text-info">
          {{balance.added_cost | roundNumber(2)}}
        </td>

        <td class="text-center">
          <i v-if="balance.is_silo_empty" class="fa fa-check"></i>
        </td>

        <td class="text-center">
          {{balance.balance_kg | roundNumber(2)}}
        </td>

        <td class="text-center" :class="{'text-danger': balance.discrepancy_kg < 0, 'text-success' : balance.discrepancy_kg > 0}">
          <i v-if="balance.discrepancy_kg < 0" class="fa fa-arrow-down"></i>
          <i v-if="balance.discrepancy_kg > 0" class="fa fa-arrow-up"></i>
          {{balance.discrepancy_kg | roundNumber(2)}}
        </td>

      </tr>
    </table>
  </div>
</template>

<style scoped>
td .add-button {
  display: none;
}
td:hover .add-button {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/layerAdmin/components/PelletFoodStockBalancesTable.vue